// src/components/white-screen-tool/ColorPicker.tsx
import { PREDEFINED_COLORS } from './constants';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface ColorPickerProps {
  onColorSelect: (color: string) => void;
}

const ColorPicker = ({ onColorSelect }: ColorPickerProps) => {
  return (
    <div className="p-4 rounded-xl border border-gray-200/50 bg-gray-800/90 backdrop-blur-sm shadow-lg">
      <div className="grid grid-cols-3 gap-3">
        {PREDEFINED_COLORS.map((color) => (
          <TooltipProvider key={color.hex}>
            <Tooltip>
              <TooltipTrigger asChild>
                <button
                  className="w-full aspect-square rounded-xl shadow-sm transition-transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 ring-offset-gray-800 overflow-hidden"
                  style={{ backgroundColor: color.hex }}
                  onClick={() => onColorSelect(color.hex)}
                  aria-label={`Select ${color.name} color (${color.hex})`}
                />
              </TooltipTrigger>
              <TooltipContent className="bg-gray-900 text-gray-100 border-gray-700">
                <p>{color.name}: {color.hex}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        ))}
      </div>
    </div>
  );
};

export default ColorPicker;